import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { GrowthContext } from './components/GrowthContext';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FooterCTA } from './components/FooterCTA';
import { ProofPopup } from './components/ProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-emerald-500 selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Features data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Modules data-id="element-4" />
      <GrowthContext data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Pricing data-id="element-7" />
      <Guarantee data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FooterCTA data-id="element-10" />

      <ProofPopup data-id="element-11" />
      <MetaPixel data-id="element-12" />

      <footer className="bg-slate-950 text-slate-500 py-6 md:py-8 text-center text-xs md:text-sm" data-id="element-13">
        <div className="container mx-auto px-4" data-id="element-14">
          <div className="flex justify-center gap-1 mb-3" data-id="element-15">
            <span className="w-2 h-2 rounded-full bg-[#008C45]" data-id="element-16" />
            <span className="w-2 h-2 rounded-full bg-white" data-id="element-17" />
            <span className="w-2 h-2 rounded-full bg-[#CD212A]" data-id="element-18" />
          </div>
          <p data-id="element-19">
            © {new Date().getFullYear()} Italiano Pro Kit. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-[10px] md:text-xs" data-id="element-20">
            Este sitio no forma parte del sitio web de Facebook ni de Facebook
            Inc.
          </p>
        </div>
      </footer>
    </div>;
}